// src/index.js
import './amplifyConfig';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import App from './App';
import theme from './theme/theme';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { InventoryProvider } from './contexts/InventoryContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CssVarsProvider theme={theme} defaultMode="dark">
    <CssBaseline />
    <AuthProvider>
      <NotificationProvider>
        <InventoryProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </InventoryProvider>
      </NotificationProvider>
    </AuthProvider>
  </CssVarsProvider>
);

// Register service worker for PWA/offline support
serviceWorkerRegistration.register();
